import { TdsGlobalFooter, TdsGlobalFooterLinks } from '@trv-tds/react';
import React from 'react';

export default function TravFooter({ footer }) {
    return (
        <TdsGlobalFooter
            sociallinks="true"
            copyright={`\u00A9 ${new Date().getFullYear()} The Travelers Indemnity Company. All rights reserved.`}
        >
            <TdsGlobalFooterLinks slot="links">
                {footer.links.map(({ id, href, label }) =>
                    href ? (
                        <a className={'footer-link'} key={id} href={href}>
                            {label}
                        </a>
                    ) : (
                        <li key={id} id={id} className="custom_QSILink"></li>
                    )
                )}
            </TdsGlobalFooterLinks>
        </TdsGlobalFooter>
    );
}
